import React from 'react'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import { Avatar, Box, InputBase, Typography } from '@mui/material'
import classes from './AppBar.module.css'
import './App.css'
import { BellIcon, dashboardCredit, searchIcon } from '../../../../assets/icons'
import { StaticAlt } from '../../../../shared/utils/constants'
import { useNavigate } from 'react-router-dom'
import { setCreditOpen } from '../../../../redux/globalSlice'
import { useDispatch } from 'react-redux'

const AppBarComp = ({ setSelectedComponent }) => {
  const drawerWidth = 240
  const storedAttributes = localStorage.getItem('userAttributes')
  const attributes = JSON.parse(storedAttributes)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const handleSearch = () => {}

  const handleCreditOpen = () => {
    dispatch(setCreditOpen(true))
  }
  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        width: `calc(100% - ${drawerWidth}px)`,
        ml: `${drawerWidth}px`,
        backgroundColor: '#fff',
        color: '#000',
        p: 0,
      }}
    >
      <Toolbar>
        <Box className="search-header">
          {/* <div className="menu-disc">
            <InputBase
              placeholder="Search"
              className="search-component"
              // value={search}
              onChange={handleSearch}
              endAdornment={
                <img src={searchIcon} alt="" style={{ width: '16px', height: '16px' }} />
              }
            />
          </div> */}
          <div className="app-bar-component">
            <div className={classes.credittab}>
              <div className={classes.subtab}>
                <img
                  onClick={handleCreditOpen}
                  src={dashboardCredit}
                  alt={StaticAlt}
                  className={classes.creditimg}
                />
                <p className={classes.credittxt}>100</p>
              </div>
              <button
                onClick={() => {
                  navigate('/credits')
                }}
                className={classes.addbtn}
              >
                +
              </button>
            </div>
            <div className="bell">
              <img src={BellIcon} alt="" />
            </div>
            <div className="divider-line"></div>
            <div onClick={() => setSelectedComponent('Profile')} className="admin-section">
              <Avatar
                variant="rounded"
                alt={attributes?.name}
                src={attributes?.employee_avatar || attributes?.employee_name}
                sx={{ width: '36px', height: '36px', bgcolor: '#F2ECF9', color: '#492972' }}
              />
              <Typography className="adminText">{attributes?.name}</Typography>
            </div>
          </div>
        </Box>
      </Toolbar>
    </AppBar>
  )
}

export default AppBarComp
